// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*DESKTOP*/
@media screen and (min-width:1024px) {
    .Relatorios_container__ts6Qo{
        width: 100%;
        overflow: hidden;
        display: flex;
        place-content: center;
    }

    .Relatorios_container__ts6Qo > div {
        width: 95%;
        font-size: 17px;
    }

    .Relatorios_datachart__GtU7J{
        width: 99%;
    }
}

/*TABLET*/
@media screen and (min-width:767px) and (max-width:1024px){
    .Relatorios_container__ts6Qo{
        width: 100%;
        overflow: hidden;
        display: flex;
        place-content: center;
    }

    .Relatorios_container__ts6Qo > div {
        width: 90%;
        font-size: 17px;
    }

    .Relatorios_datachart__GtU7J{
        width: 99%;
    }
}

/*MOBILE*/
@media screen and (max-width:767px){
    .Relatorios_container__ts6Qo{
        width: 100%;
        overflow: hidden;
        display: flex;
        place-content: center;
    }

    .Relatorios_container__ts6Qo > div {
        width: 95%;
        font-size: 17px;
    }

    .Relatorios_datachart__GtU7J{
        margin-top: 50px;
        height: 600px;
        width: 99%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/relatorios/Relatorios.module.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,aAAa;QACb,qBAAqB;IACzB;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,SAAS;AACT;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,aAAa;QACb,qBAAqB;IACzB;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,SAAS;AACT;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,aAAa;QACb,qBAAqB;IACzB;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,UAAU;IACd;AACJ","sourcesContent":["/*DESKTOP*/\n@media screen and (min-width:1024px) {\n    .container{\n        width: 100%;\n        overflow: hidden;\n        display: flex;\n        place-content: center;\n    }\n\n    .container > div {\n        width: 95%;\n        font-size: 17px;\n    }\n\n    .datachart{\n        width: 99%;\n    }\n}\n\n/*TABLET*/\n@media screen and (min-width:767px) and (max-width:1024px){\n    .container{\n        width: 100%;\n        overflow: hidden;\n        display: flex;\n        place-content: center;\n    }\n\n    .container > div {\n        width: 90%;\n        font-size: 17px;\n    }\n\n    .datachart{\n        width: 99%;\n    }\n}\n\n/*MOBILE*/\n@media screen and (max-width:767px){\n    .container{\n        width: 100%;\n        overflow: hidden;\n        display: flex;\n        place-content: center;\n    }\n\n    .container > div {\n        width: 95%;\n        font-size: 17px;\n    }\n\n    .datachart{\n        margin-top: 50px;\n        height: 600px;\n        width: 99%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Relatorios_container__ts6Qo`,
	"datachart": `Relatorios_datachart__GtU7J`
};
export default ___CSS_LOADER_EXPORT___;
